import { logInterviewPrepGenericEvent } from "./generic";
import { GenericEvent } from "../types/logging";

export const logViewJobInterviewPrepCTAShown = async (occupationSuid?: string) => {
  const params = {
    [GenericEvent.Parameter.jobOccupationSUID]: occupationSuid ?? "",
  };

  return await logInterviewPrepGenericEvent({
    eventName: GenericEvent.Name.interviewPrepPromoShown,
    eventType: "impression",
    tags: [GenericEvent.Tags.interviewPrep, GenericEvent.Tags.viewjob],
    params,
  });
};

export const logViewJobInterviewPrepCTAPressed = async (occupationSuid?: string) => {
  const params = {
    [GenericEvent.Parameter.jobOccupationSUID]: occupationSuid ?? "",
  };

  return await logInterviewPrepGenericEvent({
    eventName: GenericEvent.Name.interviewPrepPromoButtonPressed,
    eventType: "interaction",
    tags: [GenericEvent.Tags.interviewPrep, GenericEvent.Tags.viewjob],
    params,
  });
};
